import { render, staticRenderFns } from "./sha.vue?vue&type=template&id=3bd5a08e"
import script from "./sha.vue?vue&type=script&lang=js"
export * from "./sha.vue?vue&type=script&lang=js"
import style0 from "./sha.vue?vue&type=style&index=0&id=3bd5a08e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports